// extracted by mini-css-extract-plugin
export default {"overlay":"Loader_overlay__JUTOi","blur":"Loader_blur__AmyWR"};